import React from 'react';
import { Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LOGO_URL = 'https://www.sdtlab.it/assets/images/SDT_logo_2025_nobg.png';

const CompanySection = () => {
  const { t } = useLanguage();

  return (
    <section id="company" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-700 font-medium mb-4 block">{t.company.subtitle}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">{t.company.title}</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.company.description1}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.company.description2}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.company.description3}
            </p>

            {/* Quote */}
            <div className="relative bg-gray-50 rounded-2xl p-6 mt-8 border border-gray-200">
              <Quote className="absolute top-4 left-4 w-8 h-8 text-gray-300" />
              <p className="text-lg text-gray-700 italic pl-8">
                "{t.company.quote}"
              </p>
            </div>

            {/* Experience Counter */}
            <div className="flex items-center gap-6 pt-6">
              <div className="relative">
                <div className="text-6xl font-bold text-amber-700">
                  20+
                </div>
              </div>
              <div className="text-xl text-gray-600">
                {t.company.experience}
              </div>
            </div>
          </div>

          {/* Logo Visual */}
          <div className="relative flex justify-center">
            <div className="relative bg-gray-100 rounded-3xl p-12 flex items-center justify-center">
              <img
                src={LOGO_URL}
                alt="SDTLab Logo"
                className="w-64 h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySection;